import { EventService, } from '@office-start/metaos-hub-sdk';
// TODO: check if dialogService was created and if dialogPromiseHandlers is not null;
export let dialogPromiseHandlers;
/**
 * Dialog service needed in `hubServices` to use taskModuleDialog with the Hub
 *
 * @param dialogHandlers, [DialogHandlers]()
 * @returns `dialogService : IDialogService`[IDialogService](https://office.visualstudio.com/ISS/_git/metaos-hub-sdk?path=%2Fpackages%2Fmetaos-hub-sdk%2Fsrc%2FServices%2Finterfaces%2Fdialog.ts&version=GBmain&line=54&lineEnd=58&lineStartColumn=1&lineEndColumn=2&lineStyle=plain&_a=contents)
 */
export class DialogService extends EventService {
    constructor(dialogHandlers) {
        super();
        this.dialogHandlers = dialogHandlers;
        this.urlService = new DialogUrlService(this.dialogHandlers);
        this.updateService = new DialogUpdateService(this.dialogHandlers);
        this.cardService = new DialogAdaptiveCardService(this.dialogHandlers);
    }
}
class DialogUpdateService {
    constructor(dialogHandlers) {
        this.dialogHandlers = dialogHandlers;
        this.resize = (size) => {
            if (this.dialogHandlers === undefined) {
                return Promise.reject('Missing dialog handlers');
            }
            this.dialogHandlers.updateTask(size);
            return Promise.resolve();
        };
    }
}
class DialogUrlService extends EventService {
    constructor(dialogHandlers) {
        super();
        this.dialogHandlers = dialogHandlers;
        this.open = (dialog) => {
            if (dialog === undefined) {
                return Promise.reject('Missing dialog payload');
            }
            if (this.dialogHandlers === undefined ||
                !this.dialogHandlers.startTask) {
                return Promise.reject('Missing dialog handlers');
            }
            const result = new Promise((resolve, reject) => {
                dialogPromiseHandlers = {
                    externalResolver: resolve,
                    externalRejector: reject,
                };
            });
            this.dialogHandlers.startTask(dialog);
            return result;
        };
        this.submit = (results) => {
            if (this.dialogHandlers === undefined) {
                return Promise.reject('Missing dialog handlers');
            }
            this.dialogHandlers.submitTask(results);
            dialogPromiseHandlers.externalResolver(results);
            return Promise.resolve();
        };
        this.parentCommunicationService = new DialogParentCommunicationService();
    }
}
class DialogParentCommunicationService extends EventService {
    messageForParent(message) {
        this.dispatchEvent('onMessageForParent', { data: message });
        return Promise.resolve();
    }
    messageForChild(message) {
        this.dispatchEvent('onMessageForChild', { data: message });
        return Promise.resolve();
    }
}
class DialogAdaptiveCardService {
    constructor(dialogHandlers) {
        this.dialogHandlers = dialogHandlers;
        this.open = (dialog) => {
            if (dialog === undefined) {
                return Promise.reject('Missing dialog payload');
            }
            if (this.dialogHandlers === undefined ||
                !this.dialogHandlers.startTask) {
                return Promise.reject('Missing dialog handlers');
            }
            const result = new Promise((resolve, reject) => {
                dialogPromiseHandlers = {
                    externalResolver: resolve,
                    externalRejector: reject,
                };
            });
            this.dialogHandlers.startTask(dialog);
            return result;
        };
    }
}
//# sourceMappingURL=AppHostDialogService.js.map